module.exports = __webpack_public_path__ + "img/skip-backward-circle-fill.7b90b65b.svg";